import { cn } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { ComponentProps } from 'react';

type Props = ComponentProps<'div'> & {
  /** The picker sits straight on the page rather than inside its own card. */
  isOnPage: boolean;
};

/**
 * The phone's row of day tabs. On the page it gets a white card of its own; inside the picker's card it
 * bleeds past the card's padding so the tab underline runs edge to edge, as on a page header.
 */
export const DayTabList = ({ isOnPage, className, ...props }: Props) => {
  const tabList = (
    <div
      {...props}
      className={cn('flex gap-1 max-[359px]:gap-0.5', !isOnPage && '-mx-4 border-b border-border px-3', className)}
    />
  );

  // Below 360px the card's padding gives way, so "I morgen" still fits a fifth of the row.
  return isOnPage ? <NoddiBasicCard className='px-2 py-1 max-[359px]:px-1'>{tabList}</NoddiBasicCard> : tabList;
};
